import React from 'react'
import {createRole} from "../../services/serviceRole";
import {Button, Form, Input, Modal} from "antd";


const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const RoleCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()

    const handleSubmit = (list) => {
        let requestObj = {
            name: list.roleName,
            code: list.roleCode
        }
        createRole(requestObj)
            .then(() => {
                modalCloser()
                updater()
            })
    }

    return (
        <React.Fragment>
            <Modal
                title={'Rol Ekle'}
                open={show}
                closable={false}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            onClick={() => handleSubmit(form.getFieldsValue())}
                    >Kaydet</Button>,
                    <Button onClick={() => modalCloser()} key={'CancelButton'}>Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                >
                    <Form.Item
                        label={'Adı'}
                        name={'roleName'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Kodu'}
                        name={'roleCode'}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default RoleCreate